import { render, staticRenderFns } from "./VarFormSetting.vue?vue&type=template&id=150dd412"
import script from "./VarFormSetting.vue?vue&type=script&lang=js"
export * from "./VarFormSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports